import { ErrorMessage, useFormikContext } from "formik";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { ProductsResponse } from "../@types/responses";
import { Track, Values } from "@/@types/common";
import { BREAKPOINTS } from "../constants/common";
import { translation as t } from "../utils/translation";
import { ReactComponent as Arrow } from "../assets/icons/arrow.svg";
import { useWindowSize } from "../hooks/useWindowWidth";
interface TrackProps {
  track: Track;
  index: number;
  setShowResults: (value: boolean) => void;
  data: ProductsResponse | undefined;
}
const Period = ({ track, index, setShowResults, data }: TrackProps) => {
  const { setFieldValue } = useFormikContext<Values>();
  const windowWidth = useWindowSize();
  const { EXTRA_SMALL, EXTRA_EXTRA_LARGE } = BREAKPOINTS;
  const MakeMuiLiElement = function ({
    value,
    name,
  }: {
    value: string;
    name: string;
  }) {
    return (
      <MenuItem key={value} value={value}>
        <div className="wrapperLiText">{name}</div>
      </MenuItem>
    );
  };
  const periodOptions = ({
    productCode,
    scheduleId,
  }: {
    productCode: string;
    scheduleId: string;
  }) => {
    let payment = undefined;
    const selectedTrack = data?.products.find((obj) => {
      return obj.productCode.toString() == productCode;
    });
    if (
      selectedTrack !== undefined &&
      selectedTrack.paymentScheduleList !== undefined
    ) {
      payment = selectedTrack.paymentScheduleList.find(
        (payment) => payment.scheduleId.toString() == scheduleId
      );
    }
    if (payment !== undefined)
      return payment.validPeriods.map(($period) => {
        return { value: $period.toString(), name: $period.toString() };
      });
  };
  return (
    <div className={`${windowWidth > EXTRA_EXTRA_LARGE ? "my-0" : "my-3"}`}>
      <FormControl
        variant="standard"
        className={`${windowWidth > EXTRA_SMALL ? "w-[130px]" : "w-[75px]"}`}
      >
        {/* select-label-period */}
        <InputLabel id="mui-select-standard-label-period">
          {t.PERIOD}
        </InputLabel>
        <Select
          labelId="mui-select-standard-label-period"
          id="mui-select-standard-period"
          value={track.period}
          onChange={(event) => {
            setFieldValue(`tracks[${index}].period`, event.target.value);
            setFieldValue(`tracks[${index}].interestRate`, "");
            setShowResults(false);
          }}
          label="period"
          IconComponent={Arrow}
        >
          {periodOptions({
            scheduleId: track.scheduleId,
            productCode: track.productCode,
          })?.map((item) => MakeMuiLiElement(item))}
        </Select>
      </FormControl>
      <ErrorMessage
        name={`tracks[${index}].period`}
        component="div"
        className="absolute text-red"
      />
    </div>
  );
};
export default Period;